// extracted by mini-css-extract-plugin
export var cardLayout = "_7j-1";
export var paginationContainer = "_7j-0";